/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ code: NonNullable<unknown>, qty: NonNullable<unknown> }} Sl_New_Err_Source_OverInputs */

const vi_sl_new_err_source_over = /** @type {(inputs: Sl_New_Err_Source_OverInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Phiếu ${i?.code} chỉ còn ${i?.qty} kg cho phiếu nhập này`)
};

/**

* @param {Sl_New_Err_Source_OverInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const sl_new_err_source_over = /** @type {((inputs: Sl_New_Err_Source_OverInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sl_New_Err_Source_OverInputs, { locale?: "vi" }, {}>} */ ((inputs, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_sl_new_err_source_over(inputs)
});